"use client"
import Link from 'next/link'
import { useState } from 'react'

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false)
  return (
    <header className="sticky top-0 z-50 border-b border-blue-200 bg-blue-50/95 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Link href="/" className="flex items-center space-x-3 group">
              <div className="h-10 w-10 rounded-lg bg-blue-600 flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow">
                <span className="text-white font-bold text-lg">D</span>
              </div>
              <span className="text-2xl font-bold text-blue-800 group-hover:text-blue-900 transition-colors">
                デリアシ
              </span>
            </Link>
          </div>
          <nav className="hidden md:flex items-center space-x-8">
            <Link href="#features" className="text-sm font-medium text-blue-700 hover:text-blue-900 transition-colors">
              機能
            </Link>
            <Link href="#pricing" className="text-sm font-medium text-blue-700 hover:text-blue-900 transition-colors">
              料金
            </Link>
            <Link href="#about" className="text-sm font-medium text-blue-700 hover:text-blue-900 transition-colors">
              会社概要
            </Link>
            <Link href="/login" className="px-4 py-2 text-sm font-medium text-blue-700 hover:text-blue-900 transition-colors">
              ログイン
            </Link>
            <Link href="/register" className="px-6 py-2.5 text-sm font-semibold bg-orange-600 hover:bg-orange-700 text-white rounded-lg transition-all duration-200 shadow-md hover:shadow-lg">
              無料で始める
            </Link>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <button onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" className="p-2 text-blue-700 hover:text-blue-900 transition-colors">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={mobileOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
              </svg>
            </button>
          </div>
        </div>
        {/* Mobile menu panel */}
        {mobileOpen && (
          <div className="md:hidden mt-3 rounded-lg border border-blue-200 bg-white shadow-sm">
            <nav className="px-4 py-3 space-y-2">
              <Link href="#features" onClick={() => setMobileOpen(false)} className="block px-2 py-2 rounded-md text-blue-800 hover:bg-blue-50">機能</Link>
              <Link href="#pricing" onClick={() => setMobileOpen(false)} className="block px-2 py-2 rounded-md text-blue-800 hover:bg-blue-50">料金</Link>
              <Link href="#about" onClick={() => setMobileOpen(false)} className="block px-2 py-2 rounded-md text-blue-800 hover:bg-blue-50">会社概要</Link>
              <div className="h-px bg-blue-100 my-2" />
              <Link href="/login" onClick={() => setMobileOpen(false)} className="block px-2 py-2 rounded-md text-blue-800 hover:bg-blue-50">ログイン</Link>
              <Link href="/register" onClick={() => setMobileOpen(false)} className="block px-2 py-2 rounded-md bg-orange-600 text-white text-center hover:bg-orange-700">無料で始める</Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}
